type Input = Record<string, any>

// Serialize every selected slot with the same rules. Unresolved selections stay explicit so
// upload resolution or server validation can handle them; they must never become text-only runs.
export const serializeAiActionInputs = (
    inputs: Input,
    serialize: (input: Input) => Input,
    isPersistentUrl: (url: unknown) => boolean,
    hasPostImageUpload: boolean,
) => {
    const media = (input: Input | null) => {
        if (!input || typeof input !== 'object') return input
        const url = isPersistentUrl(input.url) ? input.url : null
        const payload = serialize({ ...input, url })
        if (url || payload.signed_id || payload.attachment_id || payload.blob_id) return payload
        return {
            ...payload,
            ...(input.source === 'answer_image' && hasPostImageUpload
                ? { source: 'answer_image', index: input.index ?? 0 }
                : {}),
            pending_upload: true,
        }
    }
    const result = { ...inputs }
    for (const key of ['image', 'video', 'audio', 'start_image', 'end_image']) {
        if (Object.prototype.hasOwnProperty.call(inputs, key)) result[key] = media(inputs[key])
    }
    if (Array.isArray(inputs.videos)) result.videos = inputs.videos.map(media)
    if (inputs.references && typeof inputs.references === 'object') {
        result.references = Object.fromEntries(
            Object.entries(inputs.references).map(([kind, items]) => [
                kind,
                Array.isArray(items) ? items.map(media) : items,
            ]),
        )
    }
    return result
}
